import React, { useState, useEffect, useRef } from 'react';
import { _, UserAccountService } from 'src/utils';
import { Button, Box, Link, Typography, IconButton,ArrowBackIcon, TextFieldInput, Loader, InvalidFormState, ApiError } from 'src/shared';
import '../user-account.css';
import { useTranslation } from 'src/contexts/TranslationContext';

export default function Recover({csrf, handleCurrentViewChange, handleSuccess}) {
    const [loading, set_loading] = useState(false);
    const [apiError, set_apiError] = useState(false)
    const [registrationError, set_recoverError] = useState(false)
    const [validationError, set_validationError] = useState(null)
    const [registrationSuccess, set_recoverSuccess] = useState(false)
    const timer = useRef();
    const { gettext } = useTranslation()

    useEffect(() => {
        return () => {
          clearTimeout(timer.current);
        };
    }, []);

    const handleSubmit = async (event) => {
        if (!loading) {
            set_recoverSuccess(false);
            set_loading(true);
            event.preventDefault();
            resetErrStates();
            const data = event.target;
            timer.current = window.setTimeout(async () => {
                const response = await UserAccountService.recoverUser({
                    code: data.code.value,
                    password: data.password.value,
                    confirmedPassword: data.confirmPassword.value,
                    language: "English"
                }, csrf);
                if (response == null && response == undefined) set_apiError(true);
                else if(response.error !== null && response.error !== undefined) set_validationError(response.error)
                else if (response != null) {
                    set_recoverSuccess(true);
                    handleSuccess();
                }
                else set_recoverError(true)
                set_loading(false);
            }, 1000);
        }
    };

    function resetErrStates(){
        set_apiError(false);
        set_recoverError(false);
        set_validationError(false);
    }

    return(
        <Box className="register-box box">

            <div className="title-container">
                <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                    <IconButton sx={{height: 30}} size="small" onClick={() => handleCurrentViewChange("ForgotPassword")} disableFocusRipple={true}>
                        <ArrowBackIcon fontSize="inherit" color="primary"/>
                    </IconButton>
                    <Typography variant="h4"> {gettext("Recover Account")} </Typography>
                </div>

                <Typography variant="h5"> {gettext("Enter code and new password")} </Typography>

                <div className="form-break">
                    <span className="link-container">
                        <Typography variant="body2"> {gettext(" Already have an account?")} &nbsp; </Typography>
                        <Link className="link" variant="body2" onClick={() => handleCurrentViewChange("Login")} >
                            {"Login"}
                        </Link>
                    </span>
                </div>
            </div>

            <Box component="form" onSubmit={handleSubmit} sx={{ mb: 1 }}>
                <TextFieldInput id="code" label={gettext("Code")} type="text"/>
                <TextFieldInput id="password" label={gettext("Password")} type="password"/>
                <TextFieldInput id="confirmPassword" label={gettext("Confirm Password")} type="password"/>

                { apiError ? ApiError() : null }
                { registrationError ? <InvalidFormState message={"Your request has failed. Try again"}/> : null }
                { validationError ? <InvalidFormState message={validationError}/> : null }
                { registrationSuccess ? handleCurrentViewChange("Login") : null } 

                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="small"
                    className="submit-button button"
                    sx={{marginTop: '10px'}}
                    disabled={loading}>
                        {gettext("Set Password")}
                </Button>

                {loading && (<Loader />)}
            </Box>

        </Box>
    );
}